var dropdownMenuView = document.querySelector('.collection-product-grid .dropdown-menu.swap'),
  dropdownToggleView = document.querySelector('.collection-product-grid .dropdown-toggle.swap');

var dropdownMenuSort = document.querySelector('.collection-product-grid .dropdown-menu.sort'),
  dropdownToggleSort = document.querySelector('.collection-product-grid .dropdown-toggle.sort');

// Function to toggle dropdown visibility and update ARIA attributes
function toggleDropdown(dropdownMenu, dropdownToggle) {
  if (dropdownMenu && dropdownToggle) {
    const isVisible = dropdownMenu.style.display === 'block';
    dropdownMenu.style.display = isVisible ? 'none' : 'block';
    dropdownMenu.setAttribute('aria-hidden', isVisible ? 'true' : 'false');
    dropdownToggle.setAttribute('aria-expanded', isVisible ? 'false' : 'true');
    dropdownToggle.classList.toggle('rotate', !isVisible);
  }
}

// Function to close a dropdown
function closeDropdown(dropdownMenu, dropdownToggle) {
  dropdownMenu.style.display = 'none';
  dropdownMenu.setAttribute('aria-hidden', 'true');
  dropdownToggle.setAttribute('aria-expanded', 'false');
  dropdownToggle.classList.remove('rotate');
}

// Event listener for clicking outside the dropdowns
document.addEventListener('click', (event) => {
  if (!dropdownMenuView.contains(event.target) && !dropdownToggleView.contains(event.target)) {
    closeDropdown(dropdownMenuView, dropdownToggleView);
  }

  if (!dropdownMenuSort.contains(event.target) && !dropdownToggleSort.contains(event.target)) {
    closeDropdown(dropdownMenuSort, dropdownToggleSort);
  }
});

// Update to handle aria-expanded and aria-hidden for view dropdown
function toggleViewDropdown() {
  toggleDropdown(dropdownMenuView, dropdownToggleView);
}

// Update to handle aria-expanded and aria-hidden for sort dropdown
function toggleSortDropdown() {
  toggleDropdown(dropdownMenuSort, dropdownToggleSort);
}

// Initialize the page content
document.addEventListener('DOMContentLoaded', () => {
  const hiddenSwatches = document.querySelectorAll(
    '.collection-product-grid .product-item.tile-color-swatch.herocolorswatchhidden'
  );
  const moreSwatchLink = document.querySelector('.collection-product-grid #moreHeroSwatchLink');
  if (hiddenSwatches.length > 0 && moreSwatchLink) {
    moreSwatchLink.textContent = `+${hiddenSwatches.length}`;
  }
});

// Wait for the DOM content to load
window.addEventListener('DOMContentLoaded', function () {
  // Set a timeout for 3 seconds
  setTimeout(function () {
    // Combine both selectors for refinement links and swatches
    // const interactiveElements = document.querySelectorAll('.refinement-link, .refinement-swatch_link');

    // // Add keydown event listener to each element
    // interactiveElements.forEach((element) => {
    //   element.addEventListener('keydown', function(event) {
    //     // Check if the 'Enter' key is pressed
    //     if (event.key === 'Enter') {
    //       // Trigger the click event programmatically
    //       element.click();
    //     }
    //   });
    // });
    document.addEventListener('keydown', function (event) {
      // Check if the focused element is the link and the Enter key is pressed
      if (event.key === 'Enter' && document.activeElement.classList.contains('breadcrumb-relax')) {
        // Trigger the click event programmatically
        document.activeElement.click();
      }
    });
    document.addEventListener('keydown', function (event) {
      // Check if the focused element is the link and the Enter key is pressed
      if (event.key === 'Enter' && document.activeElement.classList.contains('refinement-clear_button')) {
        // Trigger the click event programmatically
        document.activeElement.click();
      }
    });
  }, 3000); // 3000 milliseconds = 3 seconds
});
